import React, { Component } from 'react';
import '../App.css';
import { Glyphicon, OverlayTrigger, Popover }
  from 'react-bootstrap';

class Description extends Component {

  descriptionPopover(description) {
    return(
      <Popover id="popover-trigger-click-root-close">
        {description}
      </Popover>
    );
  }

  render() {
    return(
      <OverlayTrigger trigger="click" rootClose placement="right" overlay={this.descriptionPopover(this.props.description)}>
        <label type="button" className="info_button">
          <Glyphicon glyph="glyphicon glyphicon-question-sign" />
        </label>
      </OverlayTrigger>
    );
  }
}

export default Description;



// WEBPACK FOOTER //
// ./client/src/Groups/Description.js